export const whatWeOfferConfig = {
  NumberOfCardsInARow: 3,
  MaxNumberOfCards: 4,
  TileCount: 8,
  backgroundImageGradient:
    'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))',
  initialTitleDescriptionCount: 0,
  maxTitleDescriptionCount: 3,
  maxTableRowCount: 2,
  tableCellsCount: 1,
  maxPhotoTiles: 2,
  individualPhotoCount: 1,
  maxPhotoTilesInARow: 2,
  maxPhotosGalleryCount: 5,
  galleryIconSize: 28,
  maxPhotosCount: 4,
  iconSize: 38,
  iconSizeStorageTips: 28,
};
